<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/cFJUWj/tc-custom/9781504034876.jpg?1704260877225" alt="This image is the cover for the book Further Adventures of Huckleberry Finn"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Further Adventures of Huckleberry Finn
      </h1>
      <p class="bookDescription body article font2">
        <b>“The true sequel to Twain’s masterpiece.” —<i>The Christian Science Monitor</i></b><br/>  <br/> At the start of this exuberant adventure story, Huck Finn’s life is back to normal in St. Petersburg, Missouri: The Widow Douglas expects him to wear clean clothes and eat with a knife and fork, and Jim now gets paid two dollars a week for the same chores he did as a slave. But when tragedy strikes and Huck is framed for the murder of Judge Thatcher, the two old friends have no choice but to finally “light out for the Territory”—and straight into the chaos of the California Gold Rush.<br/>  <br/> With tenacious lawman Bulldog Barrett in hot pursuit, Huck and Jim zigzag west, encountering a colorful cast of con artists, vixens, outlaws, and Indians along the way. Huck’s dastardly Pap even makes an appearance, rising from a watery grave to menace his son once again. When the adventurers visit a rowdy San Francisco theater, they find their greatest surprise yet: A popular playwright has dramatized their cross-country odyssey with Huck Finn as the dastardly villain and Tom Sawyer as the noble hero.<br/>  <br/> A picaresque romp through the Old West and a heartfelt tribute to the greatest of American novels, <i>The Further Adventures of Huckleberry Finn </i>is rip-roaring fun from first page to last.<br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Greg Matthews
      </h2>
      
      <p class="authorDescription body article">Greg Matthews is the author of eleven books, including <I>The Further Adventures of Huckleberry Finn</I>, heralded by the<I> Christian Science Monitor </I>as &ldquo;the true sequel to Twain&rsquo;s masterpiece,&rdquo; and two acclaimed sagas of the Old West, <I>Heart of the Country </I>and <I>Power in the Blood</I>. He has published three books&mdash;<I>Callisto</I>, <I>The Dolphin People</I>, and <I>The Secret Book of Sacred Things</I>&mdash;under the nom de plume Torsten Krol. The author describes himself as &ldquo;a guy in a room, writing, writing.&rdquo;<BR /> &#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?e3000b76